export { C as CommunicationTypes, d as EthereumProvider, E as EthereumProviderConnectionTimeoutError, F as FamilyAccountsSdk, a as SdkStatus, b as SessionCreateResult, S as SessionStatus, c as createFamilyAccountsClient, e as familyAccountsConnector, f as familyAccountsCustomActions, p as production } from './family-accounts-connector-BEWV2sFJ.js';
import 'viem';
import 'events';

var UsernameType = /* @__PURE__ */ ((UsernameType2) => {
  UsernameType2["EMAIL"] = "EMAIL";
  UsernameType2["PHONE"] = "PHONE";
  return UsernameType2;
})(UsernameType || {});

export { UsernameType };
